<template lang="html">
	<section id="landing" :class="loaded ? 'loaded' : ''">
		<transition name="slide-fade">
			<div id="mainSlider" class="carousel" v-if="home[currentLang].diaporama">
				<agile 
					:dots="false"
					:speed="600"
					:navButtons="false"
					ref="projectsSlider"
					@after-change="forceRerender(); changeDotColor($event);"
					>
					<div class="slide" v-for="(item, index) in home[currentLang].diaporama" :key="'project'+index">
						<router-link :to="{ path: definePath(item.project.uid) }">
						<div :class="'slider-content '+ displayClass(item.template)" v-if="item.project" :style="'background-color:'+item.bgcolor+'; --linearGradient: linear-gradient('+item.bgcolor+', transparent)'">
							<div></div>
							<div :class="'slider-content--image'">
								<figure v-if="item.project.sliderCover">
									<img 
										class="toLoad"
										v-lazy="item.project.sliderCover.url"
										:srcset="item.project.sliderCover.srcset"
										sizes="(min-width: 768px) 50vw, 100vw" 
										:alt="item.project.sliderCover.alt ? item.project.sliderCover.alt : item.project.sliderCover.filename"

										/>
								</figure>
								<figure v-else>
									<img src="@/assets/img/empty.png" alt="empty-img"/>
								</figure>
							</div>
							<div class="project--infos">
								<span v-if="home[currentLang].diaporama && home[currentLang].diaporama.length" >{{index + 1}}</span><span class="discret">/{{ home[currentLang].diaporama.length }}</span>
								<p>{{item.project.title}}{{formatText(item.project.sliderInfos)}}</p>
							</div>
						</div>
						</router-link>
					</div>
				</agile>
				<div class="site--description" :class="home[currentLang].diaporama ? 'loaded' : ''" v-html="home[currentLang].mainDescription"></div>
				<div class="circleNext" @click="$refs.projectsSlider.goToNext()">
					<vue-circle
							:key="vueCircleKey"
							:ref="'updateSlide'"
							:progress="100"
							:size="43"
							:fill="fill"
							:animation="animation"
							empty-fill="rgb(255, 255, 255, .3)"
							:start-angle="-1.5"
							:thickness="1"
							:show-percent="false"
							@vue-circle-end="progress_end">
							<span class="arrow">
								<svg width="28px" height="18px" viewBox="0 0 28 18" version="1.1">
								<title>Arrow</title>
								<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
									<g transform="translate(-852.000000, -4742.000000)" stroke="#fff" stroke-width="2">
										<g transform="translate(37.000000, 4437.000000)">
											<g transform="translate(524.000000, 288.000000)">
												<g id="arrow" transform="translate(292.000000, 18.000000)">
													<line x1="0" y1="7.5" x2="22.2643382" y2="7.5" id="Line-3-Copy"></line>
													<polyline id="Path-9" transform="translate(18.303571, 8.000000) rotate(45.000000) translate(-18.303571, -8.000000) " points="13.3035714 3 22.7678571 3.53571429 23.3035714 13"></polyline>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</span>
					</vue-circle>
				</div>
			</div>
		</transition>
	</section>
</template>

<script>

import scrollBehavior  from '@/mixins/scrollBehavior.js'
import VueCircle from 'vue2-circle-progress/src/index.vue'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	mixins: [scrollBehavior,loaderHandler],
	props: ['site', 'home', 'currentLang'],
	components: {
		VueCircle
	},
	data(){
		return{
			vueCircleKey: 0,
			loaded: false,
			fill : { color: 'rgba(255, 255, 255, 1)' },
			animation: { duration: 5000, easing: 'circleProgressEasing' },
		}
	},
	watch:{
		visible(visible){
			if(visible){
				this.displayComponent(0)
			}
		}
	},
	methods:{
		displayClass(template){
			return template === 'half' ? 'half-tmp grid c-2' : 'full-tmp';
		},
		forceRerender() {
			this.vueCircleKey += 1;
		},
		progress_end(){
			this.forceRerender();
			this.$refs.projectsSlider.goToNext();
		},
		formatText(str){
			if(!str){
				return
			}
			return ' – '+str;
		},
		changeDotColor($e){
			this.$emit('dotColor', this.home[this.currentLang].diaporama[$e.currentSlide].dotcolor)
		},
		definePath(uid){
			return this.currentLang == 'fr' ? 'fr/realisations/'+uid : 'work/'+uid;
		},
	},
	mounted(){
		this.$emit('mountedLanding');
	}
}
</script>

<style lang="scss">
	#landing{
	.carousel{
		cursor: grab;
		position:relative;
		.circleNext{
			cursor:pointer;
			position:absolute;
			left:50%;
			bottom: 0;
			@include transform(translate(-50%, -50%));
			z-index:9;
			/*/ IPHONE 6 7 8 /*/
			@media only screen 
				and (min-device-width: 375px) 
				and (max-device-width: 667px) 
				and (-webkit-min-device-pixel-ratio: 2) { 
					display:none;
			}
			/*/ IPHONE 5 // GALAXY S5 /*/
			@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation : portrait) {
				display:none;
			}
			/*/ IPHONE 6+ 7+ 8+ // IPHONE 13 /*/
			@media only screen 
			and (min-device-width: 414px) 
			and (max-device-height: 736px) 
			and (orientation : portrait) 
			and (-webkit-device-pixel-ratio: 2),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (-webkit-min-device-pixel-ratio: 3),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (min--moz-device-pixel-ratio: 3),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (-o-min-device-pixel-ratio: 3/1),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (min-device-pixel-ratio: 3){
				display: block;
			}
			@media screen and (min-width:1024px){
				top:auto;
				bottom: .4rem;
			}
			.circle-percent-text-body{
				top:0;
			}
			.arrow{
				max-width:15px;
				position:absolute;
				top:50%;
				left:50%;
				@include transform(translate(-50%, -50%));
				svg{
					width:100%;
				}
			}
		}
		.site--description{
			opacity:0;
			@include transition(opacity .3s .2s, transform .5s .2s);
			position: absolute;
			top:0;
			padding: 6.5rem 2rem 0 2rem;
			@include transform(translate(0,10%));
			@media screen and (min-width:769px){
				padding:0 6rem;
				max-width: 50%;
				top: 50%;
				left: 0;
				@include transform(translate(0,-40%));
			}
			color:#fff;
			h1{
				text-align: center;
				@media screen and (max-width:1024px){
					font-size: 1.733rem;
					line-height: 2.467rem;
				}
				/*/ IPHONE 6 7 8 +/*/
				@media only screen 
					and (min-device-width: 320px) 
					and (max-device-width: 736px) 
					and (-webkit-min-device-pixel-ratio: 3),
					only screen and 
					(min-device-width: 320px) 
					and (max-device-width: 736px) 
					and (-webkit-min-device-pixel-ratio: 2) { 
					font-size: 1.6rem;
					line-height: 2rem;
				}
				/*/ IPHONE 5 // GALAXY S5 /*/
				@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation : portrait) {
					font-size: 1.35rem;
					line-height: 2rem;
				}
				@media screen and (min-width:768px){
					text-align:left;
				}
				font-family: 'surtmedium_extended', Helvetica, Arial, sans-serif;
				font-size:3rem;
				letter-spacing:0.74px;
				line-height:3.733rem;
			}
		}
	}
	.slider-content{
		opacity:0;
		color:#fff;
		position: relative;
		@include transition(opacity .3s ease);
		height: 87vh;
		overflow: hidden;
		/*/ IPHONE 5 /*/
		@media only screen and (min-device-width: 320px) and (max-device-height: 568px) and (orientation : portrait) and (-webkit-device-pixel-ratio: 2){
			height: 95vh;
		}
		/*/ IPHONE 6 7 8 /*/
		@media only screen 
			and (min-device-width: 375px) 
			and (max-device-width: 667px) 
			and (-webkit-min-device-pixel-ratio: 2) { 
			height: 95vh;
		}
		/*/ IPHONE 13 /*/
		@media only screen and (-webkit-min-device-pixel-ratio: 3),
			only screen and (min--moz-device-pixel-ratio: 3),
			only screen and (-o-min-device-pixel-ratio: 3/1),
			only screen and (min-device-pixel-ratio: 3){ 
			height: 90vh; 
		}
		@media screen and (min-width:768px){
			height: auto;
			overflow: auto;
		}
		&.grid{
			grid-gap: 0;
		}
		&:after{
			content:"";
			display: block;
			width:100%;
			height:100%;
			position:absolute;
			background:linear-gradient(transparent, rgba(0,0,0, .2));
			bottom:0;
			top:0;
			left:0;
			right:0;
		}
		.slider-content--image{
			/*/ IPHONE 6 7 8 +/*/
			@media only screen 
				and (min-device-width: 414px) 
				and (max-device-width: 736px) 
				and (-webkit-min-device-pixel-ratio: 3) { 
				margin-top:0;
			}
			figure{
				position: relative;
				display: block;
				width: 100%;
				padding: 0;
				overflow: hidden;
				&:before{
					content:"";
					display: block;
					padding-top: calc(53% + 4rem);
					@media screen and (max-width:768px){
						padding-top: 90%;
					}
					/*/ IPHONE 13 /*/
					@media 
						only screen and (min-width: 428px) and (max-height: 926px) and
						(-webkit-min-device-pixel-ratio: 3),
						only screen and (min-width: 428px) and (max-height: 926px) and
						(min--moz-device-pixel-ratio: 3),
						only screen and (min-width: 428px) and (max-height: 926px) and
						(-o-min-device-pixel-ratio: 3/1),
						only screen and (min-width: 428px) and (max-height: 926px) and
						(min-device-pixel-ratio: 3){ 
						padding-top: 110%;
					}
					/*/ IPHONE 5 // GALAXY S5 /*/
					@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation : portrait) {
						padding-top: 75%;
					}
					/*/ IPHONE 6 7 8 +/*/
					@media only screen 
						and (min-device-width: 414px) 
						and (max-device-width: 736px) 
						and (-webkit-min-device-pixel-ratio: 3) { 
						padding-top: 80%;
					}
				}
				img{
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
		&.half-tmp{
			@media screen and (max-width:768px){
				padding-top: 3rem;
			}
			.slider-content--image{
				/*/ IPHONE 5 // GALAXY S5 /*/
				@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation : portrait) {
					margin-top:5rem;
				}
				/*/ IPHONE 6 7 8 /*/
				@media only screen 
					and (min-device-width: 375px) 
					and (max-device-width: 667px) 
					and (-webkit-min-device-pixel-ratio: 2) { 
					margin-top:4rem;
				}
				/*/ IPHONE 13 /*/
				@media 
					only screen and (min-width: 428px) and (max-height: 926px) and
					(-webkit-min-device-pixel-ratio: 3),
					only screen and (min-width: 428px) and (max-height: 926px) and
					(min--moz-device-pixel-ratio: 3),
					only screen and (min-width: 428px) and (max-height: 926px) and
					(-o-min-device-pixel-ratio: 3/1),
					only screen and (min-width: 428px) and (max-height: 926px) and
					(min-device-pixel-ratio: 3){ 
					margin-top:1rem;
				}
				figure{
					&:before{
						@media screen and (min-width:768px){
							padding-top: 110.2%;
						}
						
					}
				}
			}
		}
		&.full-tmp{
			&:before{
				content:"";
				display: block;
				width:100%;
				height:100%;
				position:absolute;
				background:var(--linearGradient);
				bottom:0;
				top:0;
				left:0;
				right:0;
				opacity:.25;
				z-index:2;
			}
			.slider-content--image{
				height: 100%;
				figure{
					height:100%;
					margin-top:-2rem;
					@media screen and (max-width:768px){
						margin-top:0;
						&:before{
							padding-top: 155%;
						}
					}
				}
			}
		}
		.project--infos{
			padding: 40px 40px 20%;
			text-align: center;
			line-height: 1.5;
			@media screen and (min-width:768px){
				display:block;
				position: absolute;
				text-align: left;
				bottom: 0;
				left: 0;
				width: 100%;
				padding:2.7rem 2.2rem;
			}
			@media screen and (max-width:768px){
				padding: 2rem 2rem 22% 2rem;
				text-align: center;
				position: absolute;
				bottom: 0;
				z-index: 99;
				width: 100%;
			}
		
			/*/ IPHONE 6 7 8 /*/
			@media only screen 
				and (min-device-width: 375px) 
				and (max-device-width: 667px) 
				and (-webkit-min-device-pixel-ratio: 2) { 
					padding-bottom:25px;
			}
			/*/ IPHONE 5 // GALAXY S5 /*/
			@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation : portrait) {
				padding-bottom:25px;
				p{
					font-size: .85rem;
				}
			}
			/*/ IPHONE 6+ 7+ 8+ // IPHONE 13 /*/
			@media only screen 
			and (min-device-width: 414px) 
			and (max-device-height: 736px) 
			and (orientation : portrait) 
			and (-webkit-device-pixel-ratio: 2),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (-webkit-min-device-pixel-ratio: 3),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (min--moz-device-pixel-ratio: 3),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (-o-min-device-pixel-ratio: 3/1),
			only screen and (min-width: 428px) and (max-height: 926px) 
			and (min-device-pixel-ratio: 3){
				padding-bottom:20%;
			}
			z-index: 2;
			span{
				letter-spacing: 1.5px;
				font-family: 'surtSemiBold_extended', Helvetica, Arial, sans-serif;
				font-size: 0.867em;
					&.discret{
						opacity:.5;
					}
				}
			p{
				margin-left:1.2rem;
				display: inline-block;
				}
			}
	}
	&.loaded{
		.carousel{
			.site--description{
				opacity:1;
				@include transform(translate(0,0));
				@media screen and (min-width:769px){
					@include transform(translate(0,-50%));
				}

			}
		}
		.slider-content{
			opacity:1;
		}
	}
}
</style>
